import { SpendingHistory, SpendingHistoryDataPoint } from 'src/types/spending';
import BWDataService from './bw-data.service';
import { DateTimeFormatter, LocalDate } from '@js-joda/core';
import { SpendingSumModel } from 'src/types/spending-sum.model';
import * as _ from 'lodash';

export default class SpendingService extends BWDataService {
    public static async getSpendingSums(startDate: string, endDate: string): Promise<SpendingSumModel[]> {
        const params = new URLSearchParams({
            startDate,
            endDate
        });
        const url = `/spending/sum?${params.toString()}`;
        return await this.get(url);
    }

    public static async getSpendingSumForCategory(
        id: string,
        startDate: string,
        endDate: string
    ): Promise<SpendingSumModel> {
        const params = new URLSearchParams({
            startDate,
            endDate
        });
        const url: string = `/spending/sum/${id}?${params.toString()}`;
        return await this.get(url);
    }

    /** Get spending history from server */
    public static async getSpendingHistory(
        id: string,
        timePeriod: 'day' | 'month' | 'year',
        startDate: LocalDate,
        endDate: LocalDate,
        cumulative: boolean,
        includeTransfers: boolean
    ): Promise<SpendingHistory[]> {
        const params = new URLSearchParams({
            timePeriod,
            startDate: startDate.format(DateTimeFormatter.ISO_LOCAL_DATE),
            endDate: endDate.format(DateTimeFormatter.ISO_LOCAL_DATE),
            cumulative: cumulative.toString(),
            includeTransfers: includeTransfers.toString()
        });

        const url = `/spending/history?${params.toString()}`;
        const res: SpendingHistory[] = await this.get(url);

        // TODO this if statement is tech debt compensating for a bug in the `/spending/history{ID}` endpoint.
        //  Should be fixed once the endpoint bug is fixed
        if (id) return [res.find(({ groupId }) => groupId === id)];
        return res;
    }

    /** calculates the max height of the spending history bar chart */
    public static getHistoryBarMaxHeight(spendingHistory: SpendingHistoryDataPoint[]): number {
        return _.maxBy(spendingHistory, 'spent')?.spent || 0;
    }
}
